import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  cssVariables: true,
  typography: {
    fontFamily: "var(--font-family)",
  },
  palette: {
    primary: {
      main: "rgb(var(--primary-color))",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontSize: "1rem",
          height: "3rem",
          textTransform: "none",
          borderRadius: "0.85rem",
          fontWeight: "500",
          padding: "1rem",
          minWidth: "0",
          // fontFamily: "BDO Grotesk",
          fontFamily: "Mulish",
          "&.Mui-disabled": {
            backgroundColor: "#E5E7EB",
            color: "#9CA3AF",
            borderColor: "#E5E7EB",
            cursor: "not-allowed",
            pointerEvents: "auto",
          },
        },
        contained: ({ ownerState }) => ({
          ...(ownerState.color === "primary" || ownerState.color === "secondary"
            ? {
                color: "rgb(var(--primary-background))",
                backgroundColor: "rgba(var(--secondary-color), 0.95)",
                "&:hover": {
                  backgroundColor: "rgb(var(--secondary-color))",
                },
                "&.Mui-disabled": {
                  backgroundColor: "#E5E7EB",
                  color: "#9CA3AF",
                },
              }
            : {}),
        }),
        text: ({ ownerState }) => ({
          ...(ownerState.color === "primary" || ownerState.color === "secondary"
            ? {
                padding: "0.5rem 0.75rem",
                color: "rgb(var(--secondary-color))",
                backgroundColor: "transparent",
                borderRadius: "0.5rem",

                "&:hover": {
                  backgroundColor: "rgba(var(--secondary-color), 0.08)",
                },
                "&.Mui-disabled": {
                  backgroundColor: "transparent",
                  color: "#9CA3AF",
                },
              }
            : {}),
        }),
        outlined: ({ ownerState }) => ({
          ...(ownerState.color === "primary" || ownerState.color === "secondary"
            ? {
                backgroundColor: "transparent",
                borderColor: "rgb(var(--secondary-color))",
                color: "rgb(var(--secondary-color))",
                "&:hover": {
                  backgroundColor: "rgba(var(--secondary-color), 0.08)",
                  color: "rgb(var(--secondary-color))",
                },
                "&.Mui-disabled": {
                  backgroundColor: "transparent",
                  borderColor: "#E5E7EB",
                  color: "#9CA3AF",
                },
              }
            : {}),
        }),
      },
    },
    MuiToggleButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          border: "1px solid #5C7F71",
          // fontFamily: "BDO Grotesk",
          fontFamily: "Mulish",
          "&.Mui-selected": {
            backgroundColor: "rgb(var(--primary-color))",
            border: "transparent",
            "&:hover": {
              backgroundColor: "rgb(var(--primary-color))",
            },
          },
          "&:hover": {
            backgroundColor: "transparent",
          },
          "&.Mui-focusVisible": {
            backgroundColor: "transparent",
          },
        },
      },
    },
    
  },
});

export default theme;
